import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../services/auth.service';
import { Enums } from '../../shared/enums';
import { Utils } from '../../shared/utils';

export const authGuard: CanActivateFn = async (route, state) => {
    const router = inject(Router);
    const authService = inject(AuthService);
    const toastr = inject(ToastrService);

    const routeData: any = route.data;

    try {
        const response = await authService.getStatus();

        if (routeData.isLandingPage) {
            if (!response.data.isAuthenticated) {
                return true;
            } else {
                router.navigate([Enums.PagesPaths.Home]);
            }
        }

        if (!response.isSuccess || !response.data.isAuthenticated) {
            authService.login();
            return false;
        }

        if (authService.$user() == null || Object.keys(authService.$user()).length == 0) {
            await authService.getUserProfile(true);
        }

        if (routeData?.profiles) {
            if (routeData.profiles.includes(Enums.Profiles.ErrorPage)) {
                return true;
            }

            let remainingProfiles = [...routeData.profiles];

            if (remainingProfiles.includes(Enums.Profiles.Administrator)) {
                if (!(await authService.isAdmin())) {
                    toastr.error(Enums.Messages.NoAccessToResource, Enums.Messages.AccessDenied, Utils.getToastrErrorOptions());
                    router.navigate([Enums.PagesPaths.Error]);
                    return false;
                }

                return true;
            }

            remainingProfiles = remainingProfiles.filter(x => x != Enums.Profiles.Administrator);

            if (remainingProfiles.length > 0) {
                return authService.hasProfiles(remainingProfiles);
            }
        }

        return true;
    } catch (error) {
        console.error(error);
        authService.login();
        return false;
    }
};
